<template>
  <div class="noAuthPage">无权限</div>
</template>

<script setup lang="ts">
</script>
